import type { RowTheme } from './light'
import { commonDark } from '../../_styles/common'

const rowDark: RowTheme = {
  name: 'Row',
  common: commonDark
}

export default rowDark
